import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { NgxsRouterPluginModule } from '@ngxs/router-plugin';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsRequestsPluginModule } from 'ngxs-requests-plugin';
import { NgxsResetPluginModule } from 'ngxs-reset-plugin';
import { StateClass } from 'ngxs-reset-plugin/lib/internals';

import { environment } from '../../../environments/environment';

import { AuthState, GetUserInfoRequestState, LogOutRequestState, ResendVerificationEmailRequestState, ResetPasswordRequestState, SignInRequestState, SignUpRequestState, UpdatePasswordRequestState, UpdateUserRequestState, AcceptTermsRequestState, VerifyEmailRequestState } from './auth/auth.state';
import { FirmState, GetFirmConsultRequestState, SearchFirmRequestState, ValidateFirmIdsRequestState } from './firm/firm.state';
import { PersonState, GetPersonDetailsRequestState } from './persons/persons.state';
import { GetVariableInfoRequestState, GetVariablesPresetListRequestState, GetVariablesPresetRequestState, GetVariablesTreeRequestState, SearchVariableValueRequestState, VariablesState } from './variables/variables.state';
import { FilterState, FirmIdListState, GetFilterCountsRequestState, GetFilterPresetRequestState, GetFiltersPresetListRequestState, SaveFilterPresetRequestState, GetFirmIdListPresetListRequestState, GetFirmIdListPresetRequestState } from './filter/filter.state';
import { SaveVariablesPresetRequestState, SelectedVariablesState } from './selected-variables/selected-variables.state';
import { GetVariableSubtreeRequestState, SearchSubtreeVariableRequestState, VariablesSubtreesState } from './variables-subtrees/variables-subtrees.state';
import { SelectedSubtreeVariablesState } from './selected-subtree-variables/selected-subtree-variables.state';
import { ExtractDownloadRequestState, ExtractPreviewRequestState, GetExtractNameFromHashRequestState, ExtractState, GetAllQueriesRequestState, QueriesState, QueryState, GetQueryDetailsRequestState } from './extract/extract.state';
// import { GetQueriesPresetListRequestState, GetQueryPresetRequestState, QueryState, SaveQueryPresetRequestState } from './query/query.state';
import { GetYearListRequestState, YearsState } from './years/years.state';
import { ApplicationState } from './application/application.state';
import { PresetState, RenamePresetRequestState, RemovePresetRequestState } from './preset/preset.state';
import { ExtraOptionsState, GetExtraOptionsRequestState } from './extra-options/extra-options.state';
import { DownloadOptionsState, GetDownloadOptionsRequestState } from './download-options/download-options.state';
import { DbVersionState, GetLatestDbVersionRequestState, DbVersionsState, GetDbVersionsRequestState } from './dbVersion/dbVersion.state';
import { OwnershipState, GetOwnershipMetadataRequestState, GetOwnershipEdgesByHashRequestState, GetOwnershipNodesByHashRequestState } from './ownership/ownership.state';

import { SampleState } from './sample/sample.state';

export const STATES: StateClass[] = [
  ApplicationState,
  AuthState,
  FirmState,
  FilterState,
  FirmIdListState,
  VariablesState,
  SelectedVariablesState,
  VariablesSubtreesState,
  SelectedSubtreeVariablesState,
  ExtractState,
  QueriesState,
  PresetState,
  QueryState,
  YearsState,
  ExtraOptionsState,
  DownloadOptionsState,
  DbVersionState,
  DbVersionsState,
  SampleState,
  PersonState,
  OwnershipState
]

export const REQUESTS = [
  SignInRequestState,
  SignUpRequestState,
  VerifyEmailRequestState,
  ResendVerificationEmailRequestState,
  ResetPasswordRequestState,
  LogOutRequestState,
  GetVariablesTreeRequestState,
  GetFiltersPresetListRequestState,
  GetFilterPresetRequestState,
  GetVariableSubtreeRequestState,
  GetUserInfoRequestState,
  ExtractPreviewRequestState,
  UpdatePasswordRequestState,
  UpdateUserRequestState,
  AcceptTermsRequestState,
  GetFilterPresetRequestState,
  SaveFilterPresetRequestState,
  GetVariablesPresetRequestState,
  SaveVariablesPresetRequestState,
  // GetQueriesPresetListRequestState,
  // GetQueryPresetRequestState,
  // SaveQueryPresetRequestState,
  GetYearListRequestState,
  GetExtraOptionsRequestState,
  GetDownloadOptionsRequestState,
  GetFirmIdListPresetRequestState,
]

export const BACKGROUND_REQUESTS = [
  SearchFirmRequestState,
  GetFirmConsultRequestState,
  SearchVariableValueRequestState,
  SearchSubtreeVariableRequestState,
  ExtractDownloadRequestState,
  GetExtractNameFromHashRequestState,
  GetQueryDetailsRequestState,
  GetVariableInfoRequestState,
  GetFilterCountsRequestState,
  ValidateFirmIdsRequestState,
  GetLatestDbVersionRequestState,
  GetDbVersionsRequestState,
  GetAllQueriesRequestState,
  GetVariablesPresetListRequestState,
  GetFiltersPresetListRequestState,
  GetFirmIdListPresetListRequestState,
  RenamePresetRequestState,
  RemovePresetRequestState,
  GetPersonDetailsRequestState,
  GetOwnershipMetadataRequestState,
  GetOwnershipNodesByHashRequestState,
  GetOwnershipEdgesByHashRequestState
]

@NgModule({
  imports: [
    NgxsModule.forRoot(
      STATES,
      {
        developmentMode: !environment.production,
      },
    ),
    NgxsReduxDevtoolsPluginModule.forRoot({
      disabled: environment.production,
    }),
    NgxsRouterPluginModule.forRoot(),
    NgxsRequestsPluginModule.forRoot([...REQUESTS, ...BACKGROUND_REQUESTS]),
    NgxsResetPluginModule.forRoot(),
  ],
})
export class NgxsStoreModule {
}
